import {SmartFilterChipProps} from "./types";
import {useQuery} from "@tanstack/react-query";
import FilterChip from "./";
import {QUERY_OPTIONS_LOAD_ONCE} from "../../apiUtils";


const SmartFilterChip = <ApiResponseType, >({
  title,
  onClose,
  selection,
  queryFn,
  queryKey,
  mapQueryResponseToFilterChipLabel,
}: SmartFilterChipProps<ApiResponseType>) => {

  const {data, isLoading} = useQuery({
    queryKey: queryKey ?? [selection],
    queryFn,
    ...QUERY_OPTIONS_LOAD_ONCE,
  });


  return (
    <>
      {
        !isLoading &&
        <FilterChip
          label={mapQueryResponseToFilterChipLabel(data as ApiResponseType)}
          title={title}
          onClose={onClose}
        />
      }
    </>
  )
}


export default SmartFilterChip;